import React from 'react';
import './Footer.scss';
import {Link} from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="footer">
            <Link to="/mentions-legales" className="link">Mentions légales</Link>
        </footer>

    );
};

export default Footer;